'use strict';

angular.module('utils').factory('OCCDoctorUtil', function(CurrentUser, OCStringUtil) {
  return {
    isInsuranceAvailable: function(doctor) {
      if (!angular.isObject(doctor)) {
        return false;
      }

      var insuranceAvailable = angular.isArray(doctor.insurancePlans) && doctor.insurancePlans.length;

      if (!insuranceAvailable && angular.isArray(doctor.providers)) {
        angular.forEach(doctor.providers, function(provider) {
          if (OCStringUtil.isUnitedStates(provider.clinic.address.country)) {
            insuranceAvailable = true;
          }
        });
      }

      if (!insuranceAvailable && angular.isArray(CurrentUser.getClinics())) {
        angular.forEach(CurrentUser.getClinics(), function(clinic) {
          if (OCStringUtil.isUnitedStates(clinic.address.country)) {
            insuranceAvailable = true;
          }
        });
      }

      return insuranceAvailable;
    },
  };
});
